import CryptoJS from "crypto-js";

const Encode = () => {
    function encryptPayload(url, payload) {
        const plaintext = JSON.stringify(payload);
        const secretKeyHex = process.env.REACT_APP_VITE_SECRET_KEY;
        const ivHex = process.env.REACT_APP_VITE_IV;

        if (!secretKeyHex || !ivHex) {
            throw new Error("Environment variables are not set correctly.");
        }

        const key = CryptoJS.enc.Hex.parse(secretKeyHex);
        const iv = CryptoJS.enc.Hex.parse(ivHex);

        const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv: iv });
        const encryptedBase64 = encrypted.toString();

        console.log("Encrypted Data (Base64):", encryptedBase64);

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: encryptedBase64 }),
        })
            .then((response) => {
                if (!response.ok) {
                    console.log("entered here..", response);
                    return response;
                    // throw new Error("Network response was not ok");
                }
                console.log("entered here1", response);
                return response;
            })
            .then((responseData) => {
                console.log("entered here2", responseData);
                return responseData?.json();
            })
            .catch((error) => {
                console.log("entered here3", error);
                return error;
                // throw error;
            });
    }

    return { encryptPayload };
};

export const Encrypt = (payload) => {
    const plaintext = JSON.stringify(payload);
    const secretKeyHex = process.env.REACT_APP_SECRET_KEY;
    const ivHex = process.env.REACT_APP_IV;

    const key = CryptoJS.enc.Hex.parse(secretKeyHex);
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv: iv });
    const encryptedBase64 = encrypted.toString();

    console.log("Encrypted Data (Base64):", encryptedBase64);
    return JSON.stringify({ data: encryptedBase64 })
}

export default Encrypt;